"use client";

import { c as _c } from "react/compiler-runtime";
import { useT } from "@/lib/i18n";
import { useState, useRef, useCallback } from "react";
import RunFileHelp from "./RunFileHelp";
interface UploadProgress {
  total: number;
  done: number;
  dupes: number;
  errors: number;
}
interface RunDropZoneProps {
  onFiles: (files: FileList) => void;
  uploading?: boolean;
  uploadProgress?: UploadProgress | null;
}
export default function RunDropZone(t0) {
  const $ = _c(29);
  const {
    onFiles,
    uploading,
    uploadProgress
  } = t0;
  const t = useT();
  const [isDragging, setIsDragging] = useState(false);
  const dragCounter = useRef(0);
  const fileInputRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.preventDefault();
      e.stopPropagation();
      dragCounter.current = dragCounter.current + 1;
      setIsDragging(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleDragEnter = t1;
  const handleDragOver = _temp;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_1 => {
      e_1.preventDefault();
      e_1.stopPropagation();
      dragCounter.current = dragCounter.current - 1;
      if (dragCounter.current === 0) {
        setIsDragging(false);
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleDragLeave = t2;
  let t3;
  if ($[2] !== onFiles) {
    t3 = e_2 => {
      e_2.preventDefault();
      e_2.stopPropagation();
      e_2.nativeEvent.stopImmediatePropagation();
      dragCounter.current = 0;
      setIsDragging(false);
      if (e_2.dataTransfer.files?.length) {
        onFiles(e_2.dataTransfer.files);
      }
    };
    $[2] = onFiles;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleDrop = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => fileInputRef.current?.click();
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `border-2 border-dashed rounded-lg p-6 sm:p-8 text-center cursor-pointer transition-colors ${isDragging ? "border-[var(--accent-gold)] bg-[var(--accent-gold)]/5" : "border-[var(--border-subtle)] hover:border-[var(--border-accent)]"}`;
  let t6;
  if ($[5] !== onFiles) {
    t6 = <input ref={fileInputRef} type="file" multiple={true} accept=".run,.json" className="hidden" onChange={e_3 => {
      if (e_3.target.files) {
        onFiles(e_3.target.files);
      }
      e_3.target.value = "";
    }} />;
    $[5] = onFiles;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isDragging || $[8] !== t || $[9] !== uploadProgress || $[10] !== uploading) {
    t7 = uploading ? <p className="text-[var(--text-secondary)]">{uploadProgress ? `${t("Uploading")} ${uploadProgress.done} / ${uploadProgress.total}` + (uploadProgress.errors ? ` (${uploadProgress.errors} ${t("errors")})` : "") : t("Uploading...")}</p> : isDragging ? <p className="text-[var(--text-primary)] font-medium">{t("Drop files here...")}</p> : <p className="text-[var(--text-primary)] font-medium mb-3">{t("Drop .run files here or click to browse")}</p>;
    $[7] = isDragging;
    $[8] = t;
    $[9] = uploadProgress;
    $[10] = uploading;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isDragging || $[13] !== onFiles || $[14] !== t || $[15] !== uploading) {
    t8 = !isDragging && !uploading && <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-2 sm:gap-3" onClick={_temp2}><a href="https://www.overwolf.com/app/ptrlrd-spire_codex" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto px-5 py-2.5 sm:py-2 rounded-lg text-sm font-medium bg-[var(--accent-gold)] text-[var(--bg-primary)] hover:opacity-90 transition-opacity">{t("Download Overwolf Companion App")}</a><a href="https://steamcommunity.com/sharedfiles/filedetails/?id=3747536911" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full sm:w-auto px-5 py-2.5 sm:py-2 rounded-lg text-sm font-medium bg-[var(--accent-gold)] text-[var(--bg-primary)] hover:opacity-90 transition-opacity">{t("Get the Mod")}</a><label className="inline-flex items-center justify-center w-full sm:w-auto px-5 py-2.5 sm:py-2 rounded-lg text-sm font-medium bg-[var(--bg-primary)] text-[var(--text-primary)] border border-[var(--border-accent)] hover:bg-[var(--bg-card-hover)] transition-colors cursor-pointer">{t("Choose Files")}<input type="file" multiple={true} accept=".run,.json" className="hidden" onChange={e_5 => {
          if (e_5.target.files) {
            onFiles(e_5.target.files);
          }
          e_5.target.value = "";
        }} /></label></div>;
    $[12] = isDragging;
    $[13] = onFiles;
    $[14] = t;
    $[15] = uploading;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t || $[18] !== uploadProgress) {
    t9 = uploadProgress && <div className="mt-4"><div className="w-full bg-[var(--bg-primary)] rounded-full h-2 mb-2"><div className="h-2 rounded-full bg-[var(--accent-gold)] transition-all" style={{
          width: `${uploadProgress.done / uploadProgress.total * 100}%`
        }} /></div><p className="text-xs text-[var(--text-muted)]">{uploadProgress.done === uploadProgress.total ? <>{t("Done!")}{" "}{uploadProgress.total - uploadProgress.dupes - uploadProgress.errors}{" "}{t("submitted")}{uploadProgress.dupes > 0 && <>, {uploadProgress.dupes} {t("duplicates skipped")}</>}{uploadProgress.errors > 0 && <>, {uploadProgress.errors} {t("invalid")}</>}</> : <>{t("Processing")} {uploadProgress.done} {t("of")}{" "}{uploadProgress.total}...</>}</p></div>;
    $[17] = t;
    $[18] = uploadProgress;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <hr className="border-[var(--border-subtle)] my-4" />;
    t11 = <RunFileHelp />;
    $[20] = t10;
    $[21] = t11;
  } else {
    t10 = $[20];
    t11 = $[21];
  }
  let t12;
  if ($[22] !== handleDrop || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8 || $[27] !== t9) {
    t12 = <div onDragEnter={handleDragEnter} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} onClick={t4} className={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</div>;
    $[22] = handleDrop;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
function _temp2(e_4) {
  return e_4.stopPropagation();
}
function _temp(e_0) {
  e_0.preventDefault();
  e_0.stopPropagation();
}